import React from 'react';
import {
  Select,
  MenuItem,
  Grid,
  OutlinedInput,
  InputLabel,
  FormControl,
  Tooltip,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { observer } from 'mobx-react';

function SelectCustom(props) {
  const {
    label,
    values,
    value,
    onChange,
    valueKey = "value",
    direction = "row",
    justify = "center",
    alignItems = "center",
    className = "",
    labelPosition = "default",
    disabled = false,
    name = "",
    shouldForwardEvent = true,
    ...others
  } = props;

  let SelectComponent,
    isLabelInline = false;

  switch (labelPosition) {
    case "inline":
      SelectComponent = SelectCustomOutlinedWithInLineLabel
      isLabelInline = true;
      break;
    default:
      SelectComponent = SelectCustomOutlined;
  }

  let valuesSet = new Set(),
    valuesFiltered = values;

  valuesFiltered = valuesFiltered.filter(function (col1) {
    if (col1.$$typeof) {
      return true;
    }

    if (!col1) {
      return false;
    }
    if (valuesSet.has(col1[valueKey])) {
      return false;
    }

    valuesSet.add(col1[valueKey]);
    return true;
  });

  return (
    <Grid item container
      direction={direction}
      justify={justify}
      alignItems={alignItems}
      className={className}
      {...others}
    >
      {label && !isLabelInline && <Grid item xs={4}>
        <label>{label}</label>
      </Grid>}
      <Grid item xs>
        <SelectComponent style={{ minWidth: 120 }}
          value={typeof value == "object" ? value[valueKey] : value ?? ""}
          fullWidth
          input={
            <OutlinedInput />
          }
          name={name}
          label={label}
          disabled={disabled}
          onChange={(ev) => {
            if (shouldForwardEvent) {
              onChange(ev);
              return;
            }
            let value = ev.target.value;
            onChange(valuesFiltered.find((obj) => obj[valueKey] == value))
          }}
        >
          {
            valuesFiltered.map((item, id) => {
              if (item.$$typeof) {
                return item;
              }
              const { disabled, disabledTooltip, tooltip } = item;
              let menuItem = (
                <MenuItem key={id} value={item[valueKey]} disabled={disabled}>
                  {tooltip ? <Tooltip title={tooltip} arrow>{item.name}</Tooltip> : item.name}
                </MenuItem>
              );

              if (disabled && disabledTooltip) {
                menuItem = (
                  <Tooltip title={disabledTooltip} arrow>
                    <div>
                      {menuItem}
                    </div>
                  </Tooltip>
                )
              }
              return (
                menuItem
              )
            })
          }
        </SelectComponent>
      </Grid>
    </Grid>
  );
}

function SelectCustomOutlinedWithInLineLabel({ label, value, onChange, children, name, ...others }) {
  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);
  React.useEffect(() => {
    setLabelWidth(inputLabel && inputLabel.current ? inputLabel.current.offsetWidth : 0);
  }, []);

  return (
    <FormControl variant="outlined" {...others}>
      <InputLabel ref={inputLabel} id="select-label" >{label}</InputLabel>

      <Select style={{ minWidth: 120, height: 35 }}
        labelId="select-label"
        value={value}
        name={name}
        fullWidth
        IconComponent={ExpandMoreIcon}
        input={
          <OutlinedInput />
        }
        labelWidth={labelWidth}
        onChange={onChange}
      >
        {children}
      </Select>
    </FormControl>
  )
}

function SelectCustomOutlined({ value, onChange, children, label, name, ...others }) {
  return (
    <Select style={{ minWidth: 120 }}
      value={value}
      name={name}
      fullWidth
      input={
        <OutlinedInput />
      }
      onChange={onChange}
      {...others}
    >
      {children}
    </Select>
  );
}

export default observer(SelectCustom);